import React, { Component } from 'react';
import '../../../App.scss';
import 'antd/dist/antd.css';
import { PageHeader } from 'antd';

import AdminAllTerminalsBody from '../../../components/admin/AdminAllTerminalsBody';

// /admin/ops/terminals
export default class AdminAllTerminalsScreen extends Component {
  constructor(props) {
    super(props);
    const { isAdmin } = props;
    this.isAdmin = isAdmin;
  }

  render() {
    return (
      <div style={{ height: '100%', textAlign: 'center' }}>
        <PageHeader
          ghost={false}
          title="Terminals"
          subTitle="Fleet registry — modes, arms, history"
          onBack={() => window.history.back()}
        />
        <AdminAllTerminalsBody isAdmin={this.isAdmin} />
      </div>
    );
  }
}
